import React,{useState,useEffect,useContext} from "react"
import _ from "lodash"
import AppContext from "./AppContext";
import Api, { TOKEN, BUILD } from "./Api";
import { useGlobal } from "./Reducer";
import {Modal,ModalBody,ModalHeader,ModalFooter} from "reactstrap"


export default (props)=>{
 
    const [year,setYear]=useState(props.year)
    const [month,setMonth]=useState(props.month);


  const  getCurl=(yy,mm)=>{
        const monthName=globalState.monthNames[mm-1]+"_"+yy;
 
        const token=TOKEN;
        const prefix=`${location.protocol}//${location.host}/${BUILD}/public.html?accessToken=${token}&month=${monthName}`
        setUrl(prefix);
        
    

    }


    const [globalState,globalActions]=useGlobal();
 

    const confirmDelete=()=>{
        console.log("xxx");
        globalActions.showBooleanAlert("Sure ","are you sure you want to delete ?",()=>{
                setDeleteMode(true);
        });

    }


   useEffect(()=>{
    setYear(props.year);
    setMonth(props.month);
    openAction(props.year,props.month);

     

     
        

   },[]);

   const openAction=(yy,mm)=>{
            if(!mm)
                {
                    mm=month;
                    yy=year;
                }
console.log("loading for"+mm+","+yy);


    globalActions.loading(true);
        Api.doOpenAction(yy,mm).then(data=>{
            globalActions.setAllData(data);
            getCurl(yy,mm);
        }).catch(err=>{
          
        }).finally(()=>{
          
            globalActions.loading(false);
        });
   }


 

  

  const [url,setUrl]=useState("");
  const [deleteMode,setDeleteMode]=useState(false);
 
  
  const currentYear=new Date().getFullYear();
  //active year should contain all years from 2018 to current year + 3
    const activeYears=_.range(2018,currentYear+3); 



    return (
        <div>
            {deleteMode && <DeletePop onClose={()=>setDeleteMode(false)}
            onDelete={()=>{
                globalActions.loading(true);
                Api.doDeleteDocument(globalState.appData.id).then(()=>{
                    setDeleteMode(false);
                    openAction();
                }).catch(err=>{
                    alert(err);
                }).finally(()=>{
                    globalActions.loading(false);
                });    
           
            }}
            
            />}
    <div className="container">
<div className="card">
  <div className="card-header">
            <div className="row">
                    <div className="col-9">NewsLetter   (Logged in as {Api.info.ACCESSLEVEL==15?"Super Admin":"Admin"} )</div>
           
                    <div className="col-3  text-right">
                {false &&<button className="btn btn-primary">Edit Client Info</button>}
                <button onClick={()=>{
                    Api.doLogout();
                }} className="btn btn-danger">Logout</button>
                
            </div>
            
            </div>

  </div>
  <div className="card-body"> <div className="row ">
            <div className="col form-group">
                <label>Year:</label>
                <select value={year} onChange={e=>{
                    setYear(e.target.value);
                }} className="form-control select">
                     {_.map(activeYears,(year,index)=>{
                        return <option key={index} value={year}>{year}</option>
                     }    )}
                    
                </select>
            </div>

            <div className="col form-group">
                <label>Month:</label>
                <select value={month} onChange={e=>{
                    setMonth(e.target.value)
                }} className="form-control">
                    {_.map(globalState.monthNames,(month,index)=>{
                        return <option key={index} value={index+1}>{month}</option>
                    })}
                </select>
            </div>
          

       
            </div>
            <div className="form-group">
             
                <label>Curl for month</label>
               <input type="text" value={url} readOnly={true} className="form-control" />
            </div>
            
            </div> 
  <div className="card-footer">

  {Api.info.ACCESSLEVEL ==10 && <div style={{display:"flex",justifyContent:"space-around"}}>
  <button onClick={openAction} className="btn btn-secondary btn-lg">Open</button>


  {  globalState.appData.status=="NEW" && <button 
    onClick={()=>{
        globalActions.loading(true);
        Api.submitForReview(globalState.appData.id).then(()=>{
            globalState.appData.status='SUBMITTED';
            globalState.appData.submited_date=new Date().toString();
            globalActions.setState({});
            openAction();
        }).finally(()=>{
            globalActions.loading(false);
        });
    }}
  
  className="btn btn-info btn-lg">Submit For Review</button>}


{globalState.appData.status=="SUBMITTED"   && <div className="txt-info  ">
        Submitted For Review on {globalState.appData.submited_date} <br/>
        <button 
    onClick={()=>{
        globalActions.loading(true);
        Api.approveDocument(globalState.appData.id).then(()=>{
            globalState.appData.status='PUBLISHED';
            globalState.appData.published_date=new Date().toString();
            globalActions.setState({});
            openAction();
        }).finally(()=>{
            globalActions.loading(false);
        });
    }}
  
  className="btn btn-info btn-lg">Approve</button>

  </div>}

  {globalState.appData.status=="PUBLISHED"   && <div className="txt-info  ">
        Published on {globalState.appData.published_date}

  </div>}

  


  
  <button onClick={()=>{
      confirmDelete();
  }} className="btn btn-danger btn-lg">Delete</button>

      </div>}



 


  


 


  </div>
</div>

        
   
   </div>
   <hr/>
    </div>);
}



const DeletePop=(props)=>{

    const [a,setA]=useState(_.random(1,10,false));
    const [b,setB]=useState(_.random(1,10,false));
    const [c,setC]=useState(a+b);
    const [val,setVal]=useState(0);
    const [globalState,globalActions]=useGlobal();
    const doCheckAndDelete=()=>{
        if(val!=c)
        {
            globalActions.showAlert("Error","Please give correct answer");
            return;
        }
        props.onDelete();
    }

    return (<Modal isOpen={true}>
            <ModalHeader>Answer this to confirm</ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <label>How much is {a}+{b}?</label>
                    <input type="text" value={val}
                    onChange={(e)=>{
                        const v=e.target.value;
                         
                        setVal(v);
                    }} className="form-control"/>
                </div>
            </ModalBody>
            <ModalFooter>
                    <button onClick={doCheckAndDelete} className="btn btn-primary">Delete</button>
                    <button onClick={()=>props.onClose()} className="btn btn-secondary">Cancel</button>
            </ModalFooter>
    </Modal>);
}